import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import {
  InvalidPhoneVerificationCodeError,
  UnexpectedError,
} from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  phone: string;
  code: string;
};

export const checkAuthorisationPhoneCode = async (params: Params) => {
  const fetchURL = getM8AuthURL('checkAuthorisationPhoneCode');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 400) {
      throw new InvalidPhoneVerificationCodeError();
    }

    throw new UnexpectedError();
  }
};
